"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArray = isArray;
exports.isBoolean = isBoolean;
exports.isDate = isDate;
exports.isDefinedAndNotNull = isDefinedAndNotNull;
exports.isEmptyString = isEmptyString;
exports.isFunction = isFunction;
exports.isNull = isNull;
exports.isNumber = isNumber;
exports.isObject = isObject;
exports.isString = isString;
exports.typeOf = typeOf;
function typeOf(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
}
function isNumber(value) {
  return typeOf(value) === 'Number';
}
function isString(value) {
  return typeOf(value) === 'String';
}
function isObject(value) {
  return typeOf(value) === 'Object';
}
function isFunction(value) {
  return typeOf(value) === 'Function';
}
function isArray(value) {
  return typeOf(value) === 'Array';
}
function isBoolean(value) {
  return typeOf(value) === 'Boolean';
}
function isDate(value) {
  return typeOf(value) === 'Date';
}
function isDefinedAndNotNull(value) {
  return value !== undefined && value !== null;
}
function isNull(value) {
  return value === null;
}
function isEmptyString(value) {
  return value === '';
}